import { Loader, Stack } from "@mantine/core";

export const GenderLabLoader = () => {
  return (
    <Stack justify="center" align="center" h="90vh">
      <Loader variant="bars" />
    </Stack>
  );
};
